import { EventEmitter } from "events";
import StoreContainer from "../stores/StoreContainer";
import EcommerceService from "../services/EcommerceService";
import { EcommerceData } from "../types";

class EcommerceStore {
  private _emitter = new EventEmitter();
  private _data: EcommerceData;
  private _campaignId: string;
  private _pageUrl: string;
  private _externalId: string;
  private _externalUrl: string;

  postEcommerceData(data: EcommerceData) {
    if (!this.hasDataChanged(data)) {
      return;
    }

    this._data = data;
    StoreContainer.VisitorStore.afterLoaded(() => {
      const engagementId = StoreContainer.EngagementStore.hasEngagementId()
        ? StoreContainer.EngagementStore.getEngagementId()
        : null;
      EcommerceService.postEcommerceData(
        StoreContainer.SettingStore.getSiteId(),
        StoreContainer.VisitorStore.getVisitorId(),
        data,
        engagementId
      );
    });
  }

  private hasDataChanged(data: EcommerceData) {
    if (!this._data) {
      return true;
    }

    var newDataString = JSON.stringify(data);
    var previousDataString = JSON.stringify(this._data);
    return newDataString !== previousDataString;
  }

  linkToEcommerceCampaign(id: string, pageUrl: string) {
    if (!this.campaignHasChanged(id, pageUrl)) {
      return;
    }

    StoreContainer.VisitorStore.afterLoaded(() => {
      this._campaignId = id;
      this._pageUrl = pageUrl;
      EcommerceService.postCampaignId(
        StoreContainer.SettingStore.getSiteId(),
        StoreContainer.VisitorStore.getVisitorId(),
        id,
        pageUrl
      );
    });
  }

  private campaignHasChanged(id: string, pageUrl: string) {
    if (!this._campaignId || !this._pageUrl) {
      return true;
    }

    return this._campaignId !== id || this._pageUrl !== pageUrl;
  }

  linkToEcommerceId(id: string, url: string) {
    if (!this.ecommerceIdHasChanged(id, url)) {
      return;
    }
    StoreContainer.VisitorStore.afterLoaded(() => {
      this._externalId = id;
      this._externalUrl = url;
      EcommerceService.postExternalId(
        StoreContainer.SettingStore.getSiteId(),
        StoreContainer.VisitorStore.getVisitorId(),
        id,
        url
      );
    });
  }

  private ecommerceIdHasChanged(id: string, url: string) {
    if (!this._externalId || !this._externalUrl) {
      return true;
    }

    return id !== this._externalId || url !== this._externalUrl;
  }

  recordEcommerceSale(id: string, url: string) {
    StoreContainer.VisitorStore.afterLoaded(() => {
      EcommerceService.postSale(
        StoreContainer.SettingStore.getSiteId(),
        StoreContainer.VisitorStore.getVisitorId(),
        id,
        url
      );
    });
  }
}

export default EcommerceStore;
